// insert dropdown icons in masthead menu
$('.masthead__nav .menu > .menu-item-has-children > a').append('<i class="fas fa-chevron-down"></i>');
